// taxi-factura-oct20 (Jocelin docx Oct 14 "Seguimiento"; Roger Oct 20 "align to what they sent"):
// the two OPTIONAL post-booking answers a cita row may carry as strict booleans:
//   taxi    -> "¿Requiere el servicio de taxi?" (costo adicional)
//   factura -> "¿Requiere factura?" (constancia de situación fiscal)
// Absent key = the customer was not asked / did not answer clearly ("—"). Pure helpers shared by
// the Calendar detail panel and the Revisiones (advisor review) queue + card.
export const BOOKING_EXTRAS_FIELDS = ['taxi', 'factura'];

const strictBool = (v) => (v === true ? true : v === false ? false : null);

export const hasBookingExtras = (row) => Boolean(row)
  && BOOKING_EXTRAS_FIELDS.some((k) => strictBool(row[k]) !== null);

// [{ key, value: true|false|null }] in display order.
export const bookingExtrasEntries = (row) => BOOKING_EXTRAS_FIELDS
  .map((key) => ({ key, value: row ? strictBool(row[key]) : null }));

// "Taxi: Sí · Factura: No" (or "—" per unanswered key); '' when nothing was ever answered and
// `always` is false. `tr(key, fallback)` resolves i18n with a safe fallback.
export const formatBookingExtras = (row, tr, { always = false, dash = '\u2014' } = {}) => {
  const t = typeof tr === 'function' ? tr : (_k, f) => f;
  if (!always && !hasBookingExtras(row)) return '';
  const label = (k) => (k === 'taxi' ? t('calendar.taxi', 'Taxi') : t('calendar.factura', 'Factura'));
  const word = (v) => (v === true ? t('common.yes', 'Sí') : v === false ? t('common.no', 'No') : dash);
  return bookingExtrasEntries(row).map(({ key, value }) => `${label(key)}: ${word(value)}`).join(' \u00b7 ');
};
